import { TooltipProvider as e } from "../components/ui/tooltip.mjs";
import { jsx as t } from "react/jsx-runtime";
import { DirectionProvider as n } from "@base-ui/react";
//#region src/provider/ui-provider.tsx
var r = ({ children: r }) => /* @__PURE__ */ t(n, { children: /* @__PURE__ */ t(e, { children: r }) });
//#endregion
export { r as InfoveaveUIProvider };
